import React, { useState, useEffect, useRef } from "react";
import { Col, Row, Select, Spin, Typography } from "antd";
import NetPromoterTable from "./NetPromoterTable";
import StoreViewMid from "./StoreViewMid";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import newStyled from "@emotion/styled";
import { useNpsState } from "../../../utils/Context/NpsState";
import { base_url } from "../../../utils/apiConfig";
import { useFetchAudCycles, useFetchQueTypes } from "../../../utils/hooks/UseFetchUrl";

const { Option } = Select;

function NetPromoterScore() {
  const [selectedQueType, setSelectedQueType] = useState(null);
  const [selectedAuditCycle, setSelectedAuditCycle] = useState(null);
  const [auditCycleData, setAuditCycleData] = useState(null);
  const [barScoreData, setBarScoreData] = useState(null);
  const navigate = useNavigate();
  // const { barScoreData, setBarScoreData, auditCycleData, setAuditCycleData } = useNpsState();
  const isFirstRender = useRef(true);
  const { data: queTypesData, isLoading: queTypesLoading } = useFetchQueTypes(
    "/questionnaire_types_for_dashboard",
  );

  const {
    data: cyclesData,
    isLoading: cyclesLoading,
    error: cyclesError,
  } = useFetchAudCycles("/audit_cycle_for_dashboard");

  const filteredCycles = cyclesData?.filter(
    (cycle) => cycle.questionnaire_type?.id === selectedQueType,
  );

  useEffect(() => {
    if (queTypesData?.length > 0 && selectedQueType === null) {
      setSelectedQueType(queTypesData[0].id);
    }
  }, [queTypesData]);

  useEffect(() => {
    if (filteredCycles?.length > 0 && selectedAuditCycle === null) {
      setSelectedAuditCycle(filteredCycles[0].id);
    }
  }, [filteredCycles]);

  useEffect(() => {
    if (selectedQueType) {
      const filtered = cyclesData?.filter(
        (cycle) => cycle.questionnaire_type?.id === selectedQueType,
      );
      if (filtered && filtered.length > 0) {
        setSelectedAuditCycle(filtered[0].id);
      } else {
        setSelectedAuditCycle(null);
      }
    }
  }, [selectedQueType, cyclesData]);

  const fetchSelectedData = async () => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) return;

      const response = await axios.get(
        `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/over_all_nps_score/audit_cycle/${selectedAuditCycle}`,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        },
      );
      setBarScoreData(response.data);
    } catch (err) {
      console.log("Something went wrong, please refresh", err);
      setBarScoreData(null);
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return; // Skip first render
    }

    if (selectedAuditCycle) {
      fetchSelectedData();
    } else {
      setBarScoreData(null);
    }
  }, [selectedAuditCycle]);
  useEffect(() => {
    if (selectedAuditCycle) {
      const fetchAuditCycleData = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const response = await axios.get(
            `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/report/audit_cycle/${selectedAuditCycle}/audit_store`,
            {
              headers: {
                Authorization: `Token ${token}`,
              },
            },
          );
          const filteredData = response.data
            .map((item, index) => ({
              key: index + 1,
              sno: index + 1,
              store_name: item.store_name || "N/A",
              totalScore: item.nps_score ?? null,
              score: item.score,
              auditStoreId: item.audit_store_id,
            }))
            .filter((item) => item.totalScore !== null);

          setAuditCycleData(filteredData);
        } catch (err) {
          console.log("Something went wrong, please refresh", err);
          setAuditCycleData([]);
        }
      };

      fetchAuditCycleData();
    } else {
      setAuditCycleData(null);
    }
  }, [selectedAuditCycle]);

  const handleReportClick = async (auditStoreId) => {
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.get(
        `${base_url.protocol}://${base_url.hostname}:${base_url.port}${base_url.api_base_path}client/audit_store/${auditStoreId}`,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        },
      );
      console.log("API Response:", response.data);
      navigate(`/auditReport/${auditStoreId}`);
    } catch (error) {
      console.log("Something went wrong!!!", error);
    }
  };

  return (
    <div className="npsContainer">
      <div className="npsParaHead">
        <p className="">Net Promoter Score</p>{" "}
      </div>
      <div>
        <Row gutter={[16, 8]}>
          <Col
            xs={24}
            sm={12}
            md={12}
            lg={12}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
              maxWidth: "100%",
              flexWrap: "wrap",
            }}
          >
            <TitleStyle style={{ whiteSpace: "nowrap", minWidth: "150px" }}>
              Questionnaire Type:
            </TitleStyle>
            <CustomSelect
              value={selectedQueType}
              size="medium"
              style={{ marginBottom: "20px", flex: "1", minWidth: "180px" }}
              onChange={(value) => {
                setSelectedQueType(value);
              }}
            >
              {queTypesLoading ? (
                <Spin style={{ display: "block", margin: "20px auto" }} />
              ) : (
                queTypesData &&
                queTypesData.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.name}
                  </Option>
                ))
              )}
            </CustomSelect>
          </Col>

          <Col
            xs={24}
            sm={12}
            md={12}
            lg={12}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              width: "100%",
              maxWidth: "100%",
              flexWrap: "wrap",
            }}
          >
            <TitleStyle style={{ whiteSpace: "nowrap", minWidth: "120px" }}>
              Type of Audit:
            </TitleStyle>
            <CustomSelect
              value={selectedAuditCycle}
              size="medium"
              style={{ marginBottom: "20px", flex: "1", minWidth: "180px" }}
              onChange={(value) => {
                setSelectedAuditCycle(value);
              }}
            >
              {cyclesLoading ? (
                <Spin style={{ display: "block", margin: "20px auto" }} />
              ) : (
                filteredCycles &&
                filteredCycles.map((item) => (
                  <OptionStyle key={item.id} value={item.id}>
                    {item.name}
                  </OptionStyle>
                ))
              )}
            </CustomSelect>
          </Col>
        </Row>
      </div>
      <StoreViewMid data={barScoreData} tableData={auditCycleData} />
      <NetPromoterTable
        data={auditCycleData}
        onReportClick={handleReportClick}
      />
    </div>
  );
}

const TitleStyle = newStyled(Typography.Title)`
  font-size: 1.1rem !important;
  font-weight: 500 !important;
  font-family: 'Roboto' !important;
  color: #003d5c !important;
`;

const CustomSelect = newStyled(Select)`
  .ant-select-selector {
    // border: 1px solid rgb(149, 146, 146) !important;
    border-bottom: 2px solid rgb(194, 192, 192) !important;
    border-top: none !important;
    border-right: none !important;
    border-left: none !important;    
    border-radius: 0px !important;
  font-size: 1rem !important;
  font-weight: 500 !important;
  font-family:'Roboto', sans-serif !important;
  color: #000 !important;
    }

  :where(.css-dev-only-do-not-override-1kf000u).ant-select-single .ant-select-selector {
  border-radius: 0px !important;
  font-size: 1rem !important;
  font-weight: 500 !important;
  font-family:'Roboto', sans-serif !important;
  color: #000 !important;
}

:where(.css-dev-only-do-not-override-1kf000u).ant-select .ant-select-selection-item {
flex: 1;
    font-weight: 500 !important; 
    position: relative; 
    user-select: none;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-top: 10px!important;;
    
}
    :where(.css-1kf000u).ant-select-single.ant-select-show-arrow .ant-select-selection-item{
    font-size: 1rem !important;
  font-weight: 500 !important;
  font-family:'Roboto', sans-serif !important;
  color: #000 !important;
    }
`;

const OptionStyle = newStyled(Select.Option)`
:where(.css-dev-only-do-not-override-1kf000u).ant-select-dropdown .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
 font-family:" 'Roboto', sans-serif;
 font-size: 0.5rem !important;
 font-weight: 500 !important;
 color: #000 !important;
}

:where(.css-dev-only-do-not-override-1kf000u).ant-select-single .ant-select-selector .ant-select-selection-item, :where(.css-dev-only-do-not-override-1kf000u).ant-select-single .ant-select-selector .ant-select-selection-placeholder:{

}

:where(.css-dev-only-do-not-override-1kf000u).ant-select-single.ant-select-show-arrow .ant-select-selection-item, :where(.css-dev-only-do-not-override-1kf000u).ant-select-single.ant-select-show-arrow .ant-select-selection-search, :where(.css-dev-only-do-not-override-1kf000u).ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder{
color : red !important;
font-weight : bold !important;
}
:where(.css-dev-only-do-not-override-1kf000u).ant-select-outlined:not(.ant-select-customize-input) .ant-select-selector{
 border: 1px solid red !important;
}
`;

export default NetPromoterScore;
